import { useState } from 'react'
import type { PairedServer } from './serverList'
import { MachineList } from './MachineList'
import { terminalCreate } from '../transport/api'
import { ApiError } from '../transport/http'
import { MachineAway } from '../transport/relay'

/**
 * ＋ → TERMINAL — owner, 2026-10-18: 讓使用者可以新增一個純粹的 Terminal Session… 這個
 * Terminal Session 不需要任何的設定… 直接彈跳出來就是機器的 Home Folder.
 *
 * Your machines, each card with an Open at its right (owner, the same day: 只需要在電腦卡片
 * 的右邊增加一個 Open 的按鈕就好了, 這樣子最方便 — the first cut picked a machine and then put
 * an "Open terminal" button under the list). Open makes a tmux terminal in that machine's
 * home folder, with the person's own shell and nothing else in it. The machine makes it at
 * once (a relayed request, not the queued create an agent takes) and names it; the caller
 * opens it.
 */
export function CreateTerminalSection({ onDone }: { onDone: (session: string, deviceId: string, path: string) => void }) {
  const [busy, setBusy] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)
  const open = async (server: PairedServer) => {
    setBusy(server.server_id)
    setErr(null)
    try {
      const r = await terminalCreate(server.server_id)
      onDone(r.session, server.server_id, r.path || '~')
    } catch (e) {
      setErr(errorText(e, server.name))
    } finally {
      setBusy(null)
    }
  }
  return (
    <>
      <MachineList
        onPick={(s) => void open(s)}
        open={{ label: 'Open', busyLabel: 'Opening…', busy, onOpen: (s) => void open(s) }}
      />
      {err && (
        <p className="err-line gh-error" role="alert">
          {err}
        </p>
      )}
    </>
  )
}

/** A refusal in words: an edge older than the route answers 404 (wire-compat: new paths). */
function errorText(e: unknown, machine: string): string {
  if (e instanceof MachineAway) return `${machine} is not connected right now.`
  if (e instanceof ApiError) {
    if (e.status === 404) return `${machine} needs an Avengents update before it can open a terminal.`
    const said = (e.body as { message?: unknown } | undefined)?.message
    return typeof said === 'string' && said ? said : e.message
  }
  return `Could not open a terminal on ${machine}.`
}
